import { Fragment, useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import { Link } from "react-router-dom";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";


function FreeEdit(props)
{
       
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [view,setView] = useState('link');

    const [row, setRow] = useState( props.row );
 
 
    const [title, setTitle] = useState(props.title);

  


    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  




    const goChange = () => {
        setView("dialog");    
    }

    const closeDialog = () => {       
        setView('link');
        console.log("goclose ");
    }




    const saveTab = () => {

            setView('link');

    
       
 
                props.mainView.setProgress(-2);
        
               
        
                fetch( Config.url + '/rest_v1_emps,free_update', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                 })
                 .then(res => res.json() )
                 .then(res => { 
        
                            props.mainView.setProgress(-1);        
                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                            }else    
                            {
                                ///   
                                props.onSucess();                                             
                            }
                 } )
                 .catch(err => {          
                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            props.mainView.setProgress(-1);
                 });
                           
        
             
           
    }


 
 
 
    //console.log("VV " + JSON.stringify(row) );
 


    var dlg = null;

    if(view == 'dialog')
        {
           

            dlg = <div className="dlg_window dlg_type_y">
                    <div className="dlg_title">{title}</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                           
                        </div>

                            <div className="form_tab">                                



                               <div className="form_control">
                                    <div className="fieldName">Kategoria</div>
                                    <InputCombo  items={props.powody}  value={row.sl_powodow_nieobecnosci_id} err={errTab}  valChange={valChangeListener}  name="sl_powodow_nieobecnosci_id" placeholder={"Kategoria: "} className=' w250 ' req='1'   />
                                </div>

                                <br/>

                                <div className="form_control">
                                    <div className="fieldName">Informacje dodatkowe</div>
                                    <InputText   value={row.powod} err={errTab}  valChange={valChangeListener}  name="powod" placeholder={"Informacje dodatkowe: "} className=' w250 ' req='0'   />
                                </div>

                               

                            </div>


                    </div>

                    <div className="dlg_btn">
                          <div className="btn" atr-type="save" onClick={saveTab}>Zapisz</div>
                          &nbsp;&nbsp;
                          <div className="btn" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }

     
    if(row.skr != props.row.skr)    
        {
            setRow(props.row);
        }

 
    var defText = row.skr;
    if(defText == null) defText = '';
    if(defText.length < 1) defText = "---";
    
    return (
        <td className={props.className}>            
             <span onClick={goChange}>{defText}</span>
             {dlg}
             {props.children}
        </td>
    )
}

export default FreeEdit;
